import { action as apiAction } from 'api/Api'
import sweetalert from 'sweetalert2'

type Payload = {
  cardId: number
  template: any
  name: string
  listId: number
  position?: number
}

export default (payload: Payload) => async (dispatch, getState) => {
  const { cardId, template, name, listId, position } = payload

  const state = getState()

  const boardId = state['view-board'].cards[cardId].boardId

  try {
    const { Card } = await apiAction('AddCard', {
      template,
      listId,
      boardId: listId ? undefined : boardId,
      name: name.trim(),
      position: position ? position : 'top'
    })

    return {
      id: Card.Id
    }
  } catch (error) {
    if (error.code === 543) { // KanBo Exception: Board has no default status
      try {
        await sweetalert({
          text: getState().kanbo.locale.messages['CARD_ADD_NO_DEFAULT_STATUS'],
          type: 'info'
        })
      } catch (e) {}
    } else {
      throw error
    }
  }
}
